export const RESTART_ON_REMOUNT = '@@saga-injector/restart-on-remount';
export const DAEMON = '@@saga-injector/daemon';
export const ONCE_TILL_UNMOUNT = '@@saga-injector/once-till-unmount';
export const SEARCH_RESULTS_ERROR = 'CAT/NEXT/SEARCH/GET_SEARCH_RESULTS_ERROR';

export const Steps = {
  DONE: 'done',
};
export const XML_PAGE_TYPE = 'application/xml';
